/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ConnectedRepository = {
  repositoryId: number;
  owner: string;
  repository: string;
  private: boolean;
  defaultBranch?: string | null | undefined;
};

/** @internal */
export const ConnectedRepository$inboundSchema: z.ZodType<
  ConnectedRepository,
  z.ZodTypeDef,
  unknown
> = z.object({
  repository_id: z.number().int(),
  owner: z.string(),
  repository: z.string(),
  private: z.boolean(),
  default_branch: z.nullable(z.string()).optional(),
}).transform((v) => {
  return remap$(v, {
    "repository_id": "repositoryId",
    "default_branch": "defaultBranch",
  });
});
/** @internal */
export type ConnectedRepository$Outbound = {
  repository_id: number;
  owner: string;
  repository: string;
  private: boolean;
  default_branch?: string | null | undefined;
};

/** @internal */
export const ConnectedRepository$outboundSchema: z.ZodType<
  ConnectedRepository$Outbound,
  z.ZodTypeDef,
  ConnectedRepository
> = z.object({
  repositoryId: z.number().int(),
  owner: z.string(),
  repository: z.string(),
  private: z.boolean(),
  defaultBranch: z.nullable(z.string()).optional(),
}).transform((v) => {
  return remap$(v, {
    repositoryId: "repository_id",
    defaultBranch: "default_branch",
  });
});

export function connectedRepositoryToJSON(
  connectedRepository: ConnectedRepository,
): string {
  return JSON.stringify(
    ConnectedRepository$outboundSchema.parse(connectedRepository),
  );
}
export function connectedRepositoryFromJSON(
  jsonString: string,
): SafeParseResult<ConnectedRepository, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ConnectedRepository$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ConnectedRepository' from JSON`,
  );
}
